import { Routes } from '@angular/router';

import { authGuard } from '../../core/guards/auth.guard';
import { MEDIA_GALLERY_ROUTES } from '../media-gallery/media-gallery.routes';
import { SUBSCRIPTION_ROUTES } from '../subscription/subscription.routes';
import { provideServiceRequestFeature } from './service-request.module';

export const SERVICE_REQUEST_ROUTES: Routes = [
  {
    path: 'service-requests/create',
    providers: [provideServiceRequestFeature()],
    loadComponent: () =>
      import('./pages/create-request/create-request').then((m) => m.CreateRequest),
    data: {
      layout: {
        activeItem: 'Service Request',
        breadcrumb: 'Service Request > Create Request',
        title: 'Create Request',
        subtitle: 'Create new request on behalf of client',
        showToolbar: false,
        backTo: '/service-requests',
      },
    },
  },
  {
    path: 'service-requests/:requestId/edit',
    providers: [provideServiceRequestFeature()],
    loadComponent: () => import('./pages/edit-request/edit-request').then((m) => m.EditRequest),
    data: {
      layout: {
        activeItem: 'Service Request',
        breadcrumb: 'Service Request > Edit Request',
        title: 'Edit Request',
        subtitle: 'Update request details',
        showToolbar: false,
        backTo: '/service-requests',
      },
    },
  },
  ...MEDIA_GALLERY_ROUTES,
  ...SUBSCRIPTION_ROUTES,
  {
    path: 'service-requests/:requestId',
    providers: [provideServiceRequestFeature()],
    loadComponent: () =>
      import('./pages/request-detail/request-detail').then((m) => m.RequestDetail),
    data: {
      layout: {
        activeItem: 'Service Request',
        breadcrumb: 'View Request',
        title: 'Request Details',
        subtitle: 'View and edit request details',
        showToolbar: false,
        backTo: '/service-requests',
      },
    },
  },
  {
    path: 'service-requests',
    providers: [provideServiceRequestFeature()],
    loadComponent: () =>
      import('./pages/service-requests/service-requests').then((m) => m.ServiceRequests),
    data: {
      layout: {
        activeItem: 'Service Request',
        breadcrumb: 'Service Requests > Services',
        title: 'Service Requests',
        subtitle: 'Manage and track all service requests',
        searchPlaceholder: 'Search by Request ID/User Name/Partner/Branch...', // requests tab default; Media Gallery tab overrides via LayoutService
      },
    },
  },
];
